var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
import SortIndicator from './SortIndicator';
import { Box } from '../../Box';
import { get } from '../..';
import { getFlexAlignment } from '../utils';
var StyledTh = styled.th(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: 'inherit';\n  height: 34px;\n  text-align: ", ";\n  color: ", ";\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  white-space: normal;\n  padding: 0 10px;\n\n  &:last-child {\n    border-right: 0;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  background-color: 'inherit';\n  height: 34px;\n  text-align: ", ";\n  color: ", ";\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  white-space: normal;\n  padding: 0 10px;\n\n  &:last-child {\n    border-right: 0;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var alignment = _a.alignment;
    return alignment || 'center';
}, get.colors('slate-5'), get.colors('patina-2'));
var Header = function (_a) {
    var _b = _a.column, id = _b.id, ariaLabel = _b.ariaLabel, _c = _b.isSorted, isSorted = _c === void 0 ? false : _c, _d = _b.isSortedDesc, isSortedDesc = _d === void 0 ? false : _d, isSortable = _b.isSortable, getHeaderProps = _b.getHeaderProps, getSortByToggleProps = _b.getSortByToggleProps, render = _b.render, alignment = _b.alignment;
    var announcePolite = useAriaLive().announcePolite;
    var ref = React.useRef(null);
    var getAriaSort = function () {
        if (!isSorted)
            return 'none';
        if (isSortedDesc)
            return 'descending';
        return 'ascending';
    };
    var getFriendlyColumnName = function () {
        var _a;
        if (ariaLabel)
            return ariaLabel;
        var textContent = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent;
        if (textContent)
            return textContent;
        return id;
    };
    var getMessage = function () {
        if (isSorted) {
            return "Sorted by ".concat(getFriendlyColumnName(), " ").concat(isSortedDesc ? 'descending' : 'ascending');
        }
        return 'Not sorted';
    };
    var _e = __read(useState(false), 2), sortChanged = _e[0], setSortChanged = _e[1];
    useEffect(function () {
        if (sortChanged) {
            announcePolite(getMessage());
            setSortChanged(false);
        }
    }, [isSorted, isSortedDesc]);
    var _f = __read(useState(''), 2), columnName = _f[0], setColumnName = _f[1];
    // set column name after mount since it relies on the header being rendered
    useEffect(function () {
        setColumnName(getFriendlyColumnName());
    }, []);
    if (isSortable) {
        return (React.createElement(StyledTh, __assign({ scope: "col" }, getHeaderProps(), { "aria-sort": getAriaSort() }, (ariaLabel && { 'aria-label': ariaLabel }), { ref: ref, alignment: alignment }),
            React.createElement(Box, { onClick: function () { return setSortChanged(true); } },
                React.createElement(Box, __assign({ display: "flex", alignItems: "center", role: "button" }, getSortByToggleProps({ title: '' }), { justifyContent: getFlexAlignment(alignment), "data-track-elem": "button", "data-track-name": "".concat(columnName, " (sort)"), "data-track-state": getAriaSort() }),
                    render('Header'),
                    isSorted && React.createElement(SortIndicator, __assign({}, { isSorted: isSorted, isSortedDesc: isSortedDesc }))))));
    }
    return (React.createElement(StyledTh, __assign({ scope: "col" }, (ariaLabel && { 'aria-label': ariaLabel }), { alignment: alignment }, getHeaderProps()), render('Header')));
};
export default Header;
var templateObject_1;
//# sourceMappingURL=Header.js.map